module.exports = __webpack_public_path__ + "static/media/envase1.74342926.jpg";